/**
 * FluentUI Design Kit Tokens
 */

// Shared interface for both light and dark themes
import { darkTheme, lightTheme, FluentUIDesignKitTokens } from './index';
export type { FluentUIDesignKitTokens, ThemeColors } from './token.types';

/**
 * FluentUI Design Kit Tokens
 */
export const tokens: FluentUIDesignKitTokens = {
  // Spacing tokens - Vertical
  spacingVerticalXXS: '2px',
  spacingVerticalXS: '4px',
  spacingVerticalSNudge: '6px',
  spacingVerticalS: '8px',
  spacingVerticalM: '12px',
  spacingVerticalL: '16px',
  spacingVerticalXL: '20px',
  spacingVerticalXXL: '24px',
  spacingVerticalXXXL: '32px',

  // Spacing tokens - Horizontal
  spacingHorizontalXXS: '2px',
  spacingHorizontalXS: '4px',
  spacingHorizontalSNudge: '6px',
  spacingHorizontalS: '8px',
  spacingHorizontalM: '12px',
  spacingHorizontalL: '16px',
  spacingHorizontalXL: '20px',
  spacingHorizontalXXL: '24px',
  spacingHorizontalXXXL: '32px',

  // Typography tokens
  fontFamilyBase: '"Open Sans", "Inter", system-ui, -apple-system, sans-serif',
  fontSizeBase100: '10px',
  fontSizeBase200: '12px',
  fontSizeBase300: '14px',
  fontSizeBase400: '16px',
  fontSizeBase500: '18px',
  fontSizeBase600: '20px',
  fontSizeHero500: '20px',
  fontSizeHero900: '40px',
  fontSizeTitle3: '24px',
  fontWeightRegular: '400',
  fontWeightMedium: '500',
  fontWeightSemibold: '600',
  fontWeightBold: '700',
  lineHeightBase100: '14px',
  lineHeightBase200: '16px',
  lineHeightBase300: '20px',
  lineHeightBase400: '22px',
  lineHeightBase500: '24px',
  lineHeightBase600: '28px',
  lineHeightHero500: '28px',
  lineHeightHero900: '56px',
  lineHeightTitle3: '32px',

  // Border and shadow tokens
  borderRadiusSmall: '2px',
  borderRadiusMedium: '4px',
  borderRadiusLarge: '6px',
  borderRadiusXLarge: '8px',
  borderRadiusXXLarge: '10px',
  borderRadiusXXXLarge: '12px',
  borderRadiusXXXXLarge: '16px',
  borderRadiusHuge: '20px',
  borderRadiusCircular: '999px',
  borderRadiusNone: '0px',

  // Shadow tokens
  shadow4: '0 2px 4px rgba(0, 0, 0, 0.14), 0 0px 2px rgba(0, 0, 0, 0.12)',
  shadow8: '0 4px 8px rgba(0, 0, 0, 0.14), 0 0px 2px rgba(0, 0, 0, 0.12)',
  shadow16: '0 8px 16px rgba(0, 0, 0, 0.14), 0 2px 4px rgba(0, 0, 0, 0.12)',
  shadow64: '0 32px 64px rgba(0, 0, 0, 0.24), 0 8px 16px rgba(0, 0, 0, 0.12)',

  // Stroke widths
  strokeWidthThin: '1px',

  // Component sizing
  buttonMinWidth: '96px',

  // Color tokens by theme mode
  light: lightTheme,
  dark: darkTheme,
};
